<template>
  <SoFlowSummary :steps="steps" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoFlowSummary from "@/flows/SoFlowSummary.vue"

  export default defineComponent({
    components: {
      SoFlowSummary,
    },
    inheritAttrs: false,
    props: {
      isMeterRemindersDisabled: {
        type: Boolean,
        default: false,
      },
      isCommsDisabled: {
        type: Boolean,
        default: false,
      },
      isAccountInReview: {
        type: Boolean,
        default: false,
      },
      isActivityStreamNotified: {
        type: Boolean,
        default: false,
      },
      receivedDeathCert: {
        type: Boolean,
        default: false,
      },
      hideTitle: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      steps() {
        return [
          {
            name: "Stop meter read reminders",
            completed: this.isMeterRemindersDisabled,
          },
          {
            name: "Stop dunning and debt comms",
            completed: this.isCommsDisabled,
          },
          {
            name: "Stop bills and comms",
            completed: this.isAccountInReview,
          },
          {
            name: "Gather details of the executor of the estate",
            completed: this.isActivityStreamNotified,
          },
          {
            name: "Check death certificate",
            completed: this.receivedDeathCert,
          },
        ]
      },
    },
  })
</script>
